import { ThingEventSnapshot } from '@eagle/core-data-types';

export interface ThingEventHistoryReferenceData {
  type: 'event';
  typeId: string;
}

export const buildThingEventHistoryReferenceData = (event: ThingEventSnapshot): ThingEventHistoryReferenceData => ({
  type: 'event',
  typeId: event.eventId,
});
